export function getPlatformChecks(doc: Document) {
  const win = doc.defaultView;
  if (!win) {
    return {
      isIos: false,
      isAndroid: false,
      isStandalone: false
    };
  }
  const isIos = /iphone|ipad|ipod/i.test(win.navigator.userAgent);
  const isAndroid = /android/i.test(win.navigator.userAgent);
  const isStandalone =
    win.matchMedia('(display-mode: standalone)').matches ||
    (win.navigator as Navigator & { standalone?: boolean }).standalone === true;

  return { isIos, isAndroid, isStandalone };
}
